var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mutlinewsletter" } },
    [
      _vm.position == "page"
        ? [
            _c("div", { staticClass: "input-unit" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.multinews_vorname,
                    expression: "multinews_vorname"
                  }
                ],
                attrs: {
                  type: "text",
                  id: "multinews_vorname",
                  "aria-describedby": "multinews_vorname"
                },
                domProps: { value: _vm.multinews_vorname },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.multinews_vorname = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "multinews_vorname" } }, [
                _vm._v(
                  _vm._s(_vm.$translate("Ceres::Template.addressFirstName"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-unit" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.multinews_nachname,
                    expression: "multinews_nachname"
                  }
                ],
                attrs: {
                  type: "text",
                  id: "multinews_nachname",
                  "aria-describedby": "multinews_nachname"
                },
                domProps: { value: _vm.multinews_nachname },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.multinews_nachname = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "multinews_nachname" } }, [
                _vm._v(
                  _vm._s(_vm.$translate("Ceres::Template.addressLastName"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-unit" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.multinews_email,
                    expression: "multinews_email"
                  }
                ],
                attrs: {
                  type: "text",
                  id: "multinews_email",
                  "aria-describedby": "multinews_email"
                },
                domProps: { value: _vm.multinews_email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.multinews_email = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "multinews_email" } }, [
                _vm._v(_vm._s(_vm.$translate("Ceres::Template.myAccountEmail")))
              ])
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$translate("Woerner::Template.nlInteressen")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-wrap p-3 mb-3 bg-grey" },
              _vm._l(_vm.usernewsletter, function(nl) {
                return _c("div", { staticClass: "w-50" }, [
                  _c("div", { staticClass: "form-group form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: nl.checked,
                          expression: "nl.checked"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "newsletter_" + nl.name },
                      domProps: {
                        checked: Array.isArray(nl.checked)
                          ? _vm._i(nl.checked, null) > -1
                          : nl.checked
                      },
                      on: {
                        change: function($event) {
                          var $$a = nl.checked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(nl, "checked", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  nl,
                                  "checked",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(nl, "checked", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      staticClass: "form-check-label",
                      attrs: { for: "newsletter_" + nl.name },
                      domProps: { innerHTML: _vm._s(nl.name) }
                    })
                  ])
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-appearance btn-block",
                on: {
                  click: function($event) {
                    return _vm.newsletterSubscribe()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$translate("Woerner::Template.nlsave")))]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "mt-3 text-center" }, [
              _vm._v(_vm._s(_vm.$translate("Woerner::Template.unSubscribe")))
            ])
          ]
        : [
            _c("div", { staticClass: "widget widget-primary" }, [
              _c("div", [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$translate("Woerner::Template.nlHeader")))
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("em", [
                    _vm._v(
                      _vm._s(_vm.$translate("Woerner::Template.nlHeaderSub"))
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    { staticClass: "d-block d-lg-flex flex-lg-wrap" },
                    _vm._l(_vm.usernewsletter, function(nl) {
                      return _c(
                        "div",
                        {
                          staticClass: "form-group form-check w-25 w-100-mobil"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: nl.checked,
                                expression: "nl.checked"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "checkbox",
                              id: "newsletter_" + nl.name
                            },
                            domProps: {
                              checked: Array.isArray(nl.checked)
                                ? _vm._i(nl.checked, null) > -1
                                : nl.checked
                            },
                            on: {
                              change: function($event) {
                                var $$a = nl.checked,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(nl, "checked", $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        nl,
                                        "checked",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(nl, "checked", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", {
                            staticClass: "form-check-label",
                            attrs: { for: "newsletter_" + nl.name },
                            domProps: { innerHTML: _vm._s(nl.name) }
                          })
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right mt-2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-appearance",
                        on: {
                          click: function($event) {
                            return _vm.newsletterSubscribe()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.myAccountSave")
                          )
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }